import { useState, useEffect } from 'react'
import { api } from '../utils/api'

// /api/environment, fetched once and shared: { environment, off }.
// A failed fetch is not cached, so the next mount retries.
let pending = null
export function resetEnvironmentCache() { pending = null }
function load() { return (pending ??= api.get('/api/environment')) }

// undefined while loading, null on failure, otherwise the response body.
function useEnvironmentBody() {
  const [body, setBody] = useState(undefined)
  useEffect(() => {
    let live = true
    const p = load()
    p.then(
      (d) => { if (live) setBody(d ?? null) },
      () => { if (pending === p) pending = null; if (live) setBody(null) },
    )
    return () => { live = false }
  }, [])
  return body
}

// The environment name ('production' | 'staging').
// undefined while loading. null on failure or when the worker has no valid name: never guess.
export function useEnvironment() {
  const body = useEnvironmentBody()
  return body === undefined ? undefined : (body?.environment ?? null)
}

// The public bucket URL photo links are built on (prism-api utils/publicAssets.js),
// or null while loading, on failure, or when the server cannot work it out.
// Callers drop key-only photos on null: never guess the production host.
export function useAssetBase() {
  return useEnvironmentBody()?.assetBase ?? null
}

// The reason a feature is off here (shared/staging-features.js), or null.
// Null while loading and on failure: the UI fails open, the server-side gates are the guard.
export function useFeatureOff(key) {
  return useEnvironmentBody()?.off?.[key] ?? null
}
